import React from 'react';

import LazyImage from '@components/LazyImage';
import { useAppContext } from '@contexts/AppContext';
import { getImgxSrc } from '@utils/images';

const PartnersWhySection = (): JSX.Element => {
  const { env } = useAppContext();

  return (
    <article className="mt-48 flex flex-col items-center border-0 border-t border-solid border-grayscale-beige px-16 pt-48 sm:mt-64 sm:border-t-0 sm:px-28 sm:pt-0 md:flex-row md:gap-64 md:pr-80 lg:gap-[104px] lg:pl-0 lg:pr-28">
      <header className="order-2 mt-32 sm:order-1 sm:mt-0 lg:max-w-[512px]">
        <h2 className="my-0 font-suisse-works text-subheadline-lg sm:text-headline-md">
          Why The Information
        </h2>
        <p className="mb-0 mt-8 font-suisse-neue text-description-lg sm:text-body-lg">
          The Information is one of the most trusted and heavily cited publications covering the
          technology industry. For over a decade we have broken many of the most important articles
          in the industry — often years before other publications catch on.
        </p>
      </header>
      <LazyImage
        className="w-full"
        role="presentation"
        sizes="396px"
        src={getImgxSrc({
          path: 'partners/brand-partnerships-article-art.jpg',
          isDevDependence: true,
          envContext: env,
        })}
        wrapperClassName="block flex-shrink-0 sm:mt-48 md:mt-0 mx-auto sm:order-2 order-1 w-[70%] max-w-[396px] aspect-[33/16]"
      />
    </article>
  );
};

export default PartnersWhySection;
